module.exports = __webpack_public_path__ + "static/media/marcoRojo.3dcc6d86.svg";